import { SidekickSupportedTms } from '@shared/generated/graphql';
import { EntityInfo, SupportedEntityType, TMSPageInfo } from './types';

export function getLoadSmartPageInfo(url: string): TMSPageInfo {
  return {
    pageType: 'tms',
    tms: SidekickSupportedTms.LOADSMART,
    entityInfo: getEntityInfo(url),
  };
}

function getEntityInfo(url: string): EntityInfo[] {
  const shipmentPattern = /\/(?:loads|shipments)\/(\w+)/;
  const shipmentMatch = url.match(shipmentPattern);
  if (shipmentMatch) {
    return [
      {
        entityType: SupportedEntityType.SHIPMENT,
        entityReference: shipmentMatch[1],
      },
    ];
  }
  return [];
}
